import React, { useEffect, useRef, useState } from "react";
import { Line } from "../components/svg-components/Line";
import { Facebook } from "../components/svg-components/Facebook";
import { LinkedIn } from "../components/svg-components/LinkedIn";
import { Instagram } from "../components/svg-components/Instagram";
import { useData } from "../context/context";
import Aos from "aos";
import axios from "axios";
import { Link } from "react-router-dom";

export const Footer = () => {
  useEffect(() => {
    Aos.init();
  }, []);
  const currentYear = new Date().getFullYear();
  const { cartState, cartDispatch } = useData();
  const [tabData, setTabData] = useState([]);
  const [testTabData, setTestTabData] = useState([]);
  const [packageTabData, setPackageTabData] = useState([]);
  const [overflowingItems, setOverflowingItems] = useState([]);

  const listRef = useRef(null);

  useEffect(() => {
    const handleOverflow = () => {
      if (listRef.current) {
        const listItems = listRef.current.querySelectorAll("li");

        const overflowing = Array.from(listItems).filter((item) => {
          const listItemWidth = item.getBoundingClientRect().width;
          const parentWidth = item.parentElement.getBoundingClientRect().width;

          return listItemWidth > parentWidth;
        });

        setOverflowingItems(overflowing);
      }
    };

    handleOverflow();

    // Add event listener to handle resize
    window.addEventListener("resize", handleOverflow);

    // Cleanup function to remove event listener
    return () => window.removeEventListener("resize", handleOverflow);
  }, []);

  const handleBookHomeCollection = () => {
    // Check if you're already on the home page
    if (window.location.pathname === "/") {
      // Scroll to the element if it exists
      const homeCollectionData = document.getElementById(   
        "Home-Collection-data"
      );
      if (homeCollectionData) {
        homeCollectionData.scrollIntoView({
          behavior: "smooth",
        });
      }
    } else {
      // Navigate to the home page and scroll after loading
      window.location.href = "/#Home-Collection-data";
    }
  };

  const fetchTabData = async (category) => {
    try {
      const response = await axios.get(
        `https://triverseadvertising.com/assure_website/api/algos/fetch_details.php?category=${category}&limit=30`
      );
      return response.data.test_data;
    } catch (error) {
      console.error(`Error fetching ${category} data:`, error);
      return [];
    }
  };

  useEffect(() => {
    const abortController = new AbortController();

    const fetchTestTabData = async () => {
      try {
        const testData = await fetchTabData("test", abortController.signal);
        setTestTabData(testData);
      } catch (error) {
        console.error("Error fetching test data:", error);
      }
    };

    const fetchPackageTabData = async () => {
      try {
        const packageData = await fetchTabData(
          "package",
          abortController.signal
        );
        setPackageTabData(packageData);
      } catch (error) {
        console.error("Error fetching package data:", error);
      }
    };

    fetchTestTabData();
    fetchPackageTabData();

    return () => {
      abortController.abort();
    };
  }, []);

  const toggleCart = () => {
    cartDispatch({ type: "TOGGLE_CART" });
  };

  const menuItems = [
    {
      title: "About Us",
      aosDelay: 200,
      href: "/about-us",
      // links: [{ href: "/about-us", label: "ABOUT US" }],
    },
    {
      title: "Our Doctors",
      href: "/doctors",
      aosDelay: 300,
      links: [
        {
          href: "/doctors/dr-sanjay-wadhwa",
          label: "DR. SANJAY WADHWA",
        },
        {
          href: "/doctors/dr-lovely-razdan",
          label: "DR. LOVELY RAZDAN",
        },
      ],
    },
    {
      title: "Services",
      aosDelay: 400,
      links: [
        { label: "HOME SAMPLE COLLECTION" },
        {
          href: "/pharmacy",
          label: "MEDICINES",
        },
        { label: "X-RAY" },
      ],
    },
    {
      title: "Booking",
      aosDelay: 500,
      links: [
        { href: "/packages", label: "BOOK A PACKAGE" },
        { href: "/all-test", label: "BOOK A TEST" },
      ],
    },
    {
      title: "My Account",
      aosDelay: 600,
      links: [
        {
          label: "MY CART",
          onClick: toggleCart,
        },
        { label: "BLOG" },
        {
          href: "https://patients.assurepathlabs.com/patient/login",
          label: "LOGIN",
          external: true,
        },
      ],
    },
  ];

  return (
    <>
      <footer className="col-12 float-start position-relative">
        <div className="footergray pb-0 col-12 float-start">
          <div className="container">
            <div className="">
              <div className="row mb-3 pb-3">
                <div
                  className="_acc flex-center  flex-column "
                  data-aos="fade-up"
                  data-aos-duration={500}
                  data-aos-once="true"
                  data-aos-easing="ease-in"
                  data-aos-delay={150}
                >
                  <div className="popular_packages">
                    <div
                      className="popular_packaes_title"
                      data-aos="fade-up"
                      data-aos-duration={300}
                      data-aos-once="true"
                      data-aos-easing="ease-in"
                      data-aos-delay={150}
                    >
                      <strong>Popular Test</strong>
                    </div>
                    <div className="popular_packages_cnt">
                      <ul
                        className="flex-center "
                        data-aos="fade-up"
                        data-aos-duration={500}
                        data-aos-once="true"
                        data-aos-easing="ease-in"
                        data-aos-delay={150}
                      >
                        {testTabData.slice(0, 31).map((test, index) => (
                          <li title={test.Test_Name}>
                            <Link key={test.id} to={`/all-test/${test.Slug}`}>
                              {test.Test_Name}
                            </Link>
                          </li>
                        ))}
                        <li title={"View More"} className="ViewMore_footer">
                          <Link to={`/all-test`}>View More...</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="popular_packages mt-5 pt-4 bt">
                    <div
                      className="popular_packaes_title"
                      data-aos="fade-up"
                      data-aos-duration={600}
                      data-aos-once="true"
                      data-aos-easing="ease-in"
                    >
                      <strong>Popular Packages</strong>
                    </div>
                    <div className="popular_packages_cnt">
                      <ul
                        className="flex-center "
                        data-aos="fade-up"
                        data-aos-duration={600}
                        data-aos-once="true"
                        data-aos-easing="ease-in"
                      >
                        {packageTabData.slice(0, 27).map((test, index) => (
                          <li title={test.Test_Name}>
                            <Link key={test.id} to={`/packages/${test.Slug}`}>
                              {test.Test_Name}
                            </Link>
                          </li>
                        ))}
                        <li title={"View More"} className="ViewMore_footer">
                          <Link to={`/packages`}>View More...</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Line className="svgwidthline position-absolute top-0 end-0" />
        </div>
        <div className="footergray _chnage_color mt-0 pb-0  col-12 float-start">
          <div className="container ">
            <div className="row footer_bottom pb-4">
              <div
                className="col-xl-9 col-md-8 float-end d-flex justify-content-between ftrSitemap"
                data-aos="fade-in"
                data-aos-delay={150}
                data-aos-duration={600}
                data-aos-once="true"
                data-aos-easing="ease-in"
              >
                {menuItems.map((menuItem, index) => (
                  <div key={index} className="footercolumn">
                    <div className="fheading">
                      <article className="text-uppercase">
                        {menuItem.href ? (
                          <Link to={menuItem.href}>{menuItem.title}</Link>
                        ) : (
                          <span>{menuItem.title}</span>
                        )}
                      </article>
                    </div>
                    {menuItem.links && (
                      <div className="fmenu">
                        <ul className="p-0 m-0">
                          {menuItem.links.map((link, linkIndex) => (
                            <li key={linkIndex}>
                              {link.external ? (
                                <a
                                  to={link.href}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-black"
                                >
                                  {link.label}
                                </a>
                              ) : link.href ? (
                                <Link to={link.href}>{link.label}</Link>
                              ) : (
                                <span onClick={link.onClick}>{link.label}</span> // Add this line to handle undefined href
                              )}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                ))}
              </div>
              <div
                className="col-xl-3 col-md-4 col-sm-12 contact_detail"
                data-aos="fade-in"
                data-aos-duration={600}
                data-aos-once="true"
                data-aos-easing="ease-in"
              >
                <div className="contact">
                  <a to="tel:0181-4667555">
                    <span className="flex-center align-items-start gap-2 sm-gap-4">
                      <strong>T</strong>
                      0181-4667555
                    </span>
                  </a>
                </div>
                <div className="">
                  <div className="contact">
                    <a to="mailto:assurepathlabs@gmail.com">
                      <span className="flex-center align-items-start gap-2 sm-gap-4">
                        <strong>E</strong>
                        assurepathlabs@gmail.com
                      </span>
                    </a>
                  </div>
                </div>
                <div className=" ">
                  <div className="contact">
                    <span className="flex-center align-items-start gap-2 gap-sm-0">
                      <strong>A </strong>
                      &nbsp;77, Urban Estate
                      <br /> Phase-II, Jalandhar
                    </span>
                  </div>
                </div>
                <div className="socail_icon">
                  <div className="">
                    <Link
                      to="https://www.facebook.com/assurepathlabsjalandhar/"
                      target="_blank"
                    >
                      <Facebook />
                    </Link>
                  </div>
                  <div className="">
                    <Link
                      to="https://www.instagram.com/assurepathlabs/"
                      target="_blank"
                    >
                      <Instagram />
                    </Link>
                  </div>

                  <div className="">
                    <Link
                      to="https://www.linkedin.com/company/assurepathlabs/"
                      target="_blank"
                    >
                      <LinkedIn />
                    </Link>
                  </div>
                  {/* <div className="">
                    <Link to="#">
                      <Youtube />
                    </Link>
                  </div>
                  <div className="">
                    <Link to="#">
                      <Twitter />
                    </Link>
                  </div> */}
                </div>
                <div className="col-12  mx-auto  flex-center ">
                  <Link
                    // to="/check-out"
                    className="button button--aylen button--round-l footer_btn button--text-thick text-uppercase gradient justify-content-start"
                    onClick={handleBookHomeCollection}
                  >
                    BOOK HOME COLLECTION
                  </Link>
                </div>
              </div>
            </div>

            <div className="row pt-sm-3 pt-2 pb-1">
              <div className=" footer_site">
                <p className="m-0">
                  *Home collection is free for bill amounts exceeding 1k and
                  within a 7km radius.
                </p>
              </div>
            </div>
            <div className="row pb-sm-3 pb-2 ">
              <div className=" footer_site">
                <p className="m-0">
                  &copy; {currentYear} All Rights Reserved.{" "}
                </p>
                <p className="m-0">
                  <Link to="/terms-conditions">Terms & conditions</Link>
                </p>
                <p className="m-0">
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </p>
                <p className="m-0">
                  <Link to="/refund-cancellation">Refund and Cancellation</Link>
                </p>
              </div>
              <div className=" _cerdit text-end">
                <p className="m-0">
                  <a to="https://triverseadvertising.com/" target="_blank">
                    site : triverse
                  </a>
                </p>
              </div>
            </div>
          </div>
          <Line className="svgwidthline position-absolute top-0 end-0" />
        </div>
      </footer>
    </>
  );
};
